import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IEntityGroup } from './entityGroup'
import { ODataService } from 'common-services'

export interface IEntityGroupPlan extends IModelBase {
  EntityGroupId: number
  EntityGroup: IEntityGroup

  PayerId: number
  PayerKey: string
  PayerName: string

  PlanId: number
  PlanKey: string
  PlanName: string

  LineOfBusinessId: number
  LineOfBusinessKey: string
  LineOfBusinessName: string
}

@Injectable()
export class EntityGroupPlanODataService extends ODataService<IEntityGroupPlan> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'EntityGroupPlans'
  }
}
